import {
	GET_MEMBERSHIPS_USERS_SUCCESS,
	DELETE_USER_SUCCESS,
    DELETE_USER_ERROR,
    INVITE_MEMBER,
    UPDATE_MEMBERINVITATION
} from '../../Actions/EndUser/MemberInvitationAction';

const initialState = {
	membershipUsers:[],
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_MEMBERSHIPS_USERS_SUCCESS:
			return {
				...state,
				membershipUsers: action.payload
			};
		case DELETE_USER_SUCCESS:
			return {
				...state,
				membershipUsers: action.payload
			};
		case DELETE_USER_ERROR:
			return {
				...state,
				error: action.payload
			};
		case INVITE_MEMBER:
            return {
                ...state,
                membershipUsers: action.payload
            }; 
        case UPDATE_MEMBERINVITATION:
            return {
                ...state,
                membershipUsers: action.payload
            };  
		default:
			return state;
	}
};
